module.exports = __webpack_public_path__ + "img/coin25.6139eadd.png";